module.exports = __webpack_public_path__ + "img/261.cd156822.jpg";